"use client"

import { useTheme } from './ThemeProvider'
import { Moon, Sun } from 'lucide-react'
import { Button } from './ui/button'
import { motion } from 'framer-motion'

export function ThemeToggle() {
  const { theme, toggleTheme } = useTheme()

  const handleToggle = () => {
    // console.log('=== THEME TOGGLE DEBUG ===')
    // console.log('Current theme before toggle:', theme)
    // console.log('Document classes before toggle:', document.documentElement.classList.toString())
    
    toggleTheme()
    
    // Debug: Check if document class was updated
    setTimeout(() => {
      // console.log('Document classes after toggle:', document.documentElement.classList.toString())
      // console.log('Is dark class present:', document.documentElement.classList.contains('dark'))
      // console.log('Is light class present:', document.documentElement.classList.contains('light'))
      // console.log('Current theme state:', theme)
      
      // Test if Tailwind dark mode is working
      const testElement = document.createElement('div')
      testElement.className = 'bg-white dark:bg-black w-4 h-4'
      document.body.appendChild(testElement)
      const computedStyle = window.getComputedStyle(testElement)
      console.log('Test element background color:', computedStyle.backgroundColor)
      document.body.removeChild(testElement)
    }, 100)
  }

  return (
    <motion.div
      className="relative w-7 h-7 rounded-lg bg-light-accent/20 dark:bg-slate-800/50 hover:bg-light-accent/50 dark:hover:bg-slate-800/70 border border-light-border/30 dark:border-slate-700/50 transition-all duration-300 group cursor-pointer flex items-center justify-center"
      onClick={handleToggle}
      aria-label={`Switch to ${theme === 'light' ? 'dark' : 'light'} mode`}
    >
      <motion.div
        className="flex items-center justify-center"
        initial={false}
        animate={{ rotate: theme === 'light' ? 180 : 0 }}
        transition={{ duration: 0.3, ease: "easeInOut" }}
      >
        {theme === 'light' ? (
          <Sun className="w-4 h-4 text-amber-500 group-hover:scale-110 transition-transform duration-200" />
        ) : (
          <Moon className="w-4 h-4 text-blue-400 group-hover:scale-110 transition-transform duration-200" />
        )}
      </motion.div>
      
      {/* Theme indicator ring */}
      <motion.div
        className="absolute inset-0 rounded-lg border-2 border-transparent"
        initial={false}
        animate={{
          borderColor: theme === 'light' ? '#f59e0b' : '#60a5fa',
          opacity: [0, 0.3, 0]
        }}
        transition={{
          duration: 0.6,
          ease: "easeOut"
        }}
      />
    </motion.div>
  )
}
